import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {EmployeeNameWithAvatar, InteractiveTable} from 'components';
import {SurveyEmployeeStatus} from 'main/stores/surveys';
import {FormattedMessage} from 'react-intl';

const EmployeeName = observer(({model}) => {
  return (
    <EmployeeNameWithAvatar employee={model.employee} />
  );
});

const Status = observer(({model}) => {
  return (
    <FormattedMessage id={`surveys.view.${model.submitted ? 'Submitted' : 'Pending'}`} />
  );
});

const SURVEY_COLUMNS = [
  {
    header: 'surveys.view.Assignee',
    width: 3,
    component: EmployeeName,
    sortBy: 'employeeName',
  },
  {
    header: 'surveys.view.Status',
    width: 2,
    sortBy: 'submittedAt',
    component: Status
  },
  {
    header: 'surveys.view.Due Date',
    render: model => model.dueDateView,
    width: 3,
    sortBy: 'dueDate'
  },
  {
    header: 'surveys.view.Completed Date',
    render: model => model.submittedAtView,
    width: 3,
    sortBy: 'submittedAt'
  }
];

const ANONYMOUS_SURVEY_COLUMN = [
  {
    header: 'surveys.view.Assignee',
    width: 11,
    component: EmployeeName,
    sortBy: 'employeeName',
  }
];

const LOCALIZATION = {
  interactive: {
    addModel: 'surveys.view.+ Add Assignees',
  },
  removeModal: {
    header: 'surveys.view.Remove Assignee',
    subHeader: 'surveys.view.Are you sure you want to remove this assignee from the survey?',
    body: 'surveys.view.The employee will be removed from the survey, and their response will be permanently deleted.'
  }
};

const ResponseTable = observer(({uiState}) => {
  const {match, survey} = uiState;

  const columns = survey.anonymous ?
    ANONYMOUS_SURVEY_COLUMN :
    SURVEY_COLUMNS;

  return (
    <InteractiveTable
      title={t('surveys.view.Assigned Employees')}
      columns={columns}
      localization={LOCALIZATION}
      onMount={agent => uiState.setAgent(agent)}
      onAdd={() => uiState.openSelectEmployeesModal()}
      initialSorting={{employeeName: 'asc'}}
      showAddButton={survey.hasLink('addAssignees')}
      onRemove={model => uiState.removeEmployeeStatus(model)}
      showRoute={model => !survey.anonymous && model.submitted ? `/manage/survey/${survey.id}/response/${model.employee.id}` : null}
      proxy={{
        type: 'async',
        modelType: types.SURVEYS.EMPLOYEE_STATUS,
        model: SurveyEmployeeStatus,
        endpoint: endpoints.SURVEYS.EMPLOYEE_STATUSES.ALL.with(match.params.id)
      }}
    />
  );
});

export default ResponseTable;
